import Home from './home'
import Mix from './mix'
import Monitor from './monitor'
import RemoteControl from './remote'

export default {
    Home,
    Mix,
    Monitor,
    RemoteControl
}